<template>
  <div class="orderList">
    <!-- <van-nav-bar title="我的订单"
                 @click-left="onClickLeft"
                 left-arrow>

    </van-nav-bar> -->

    <van-tabs :active="active">
      <van-tab title="已支付">
        <div class='order-section'
             v-if='this.goods!=0'>
          <van-card v-for="item in goods"
                    :title="item.name"
                    :desc="item.color +'-'+ item.size"
                    :num="item.count"
                    :price="item.price"
                    :thumb="item.goodsDetail.src"
                    :key="item.id">
            <div slot="footer"
                 v-if='item.whichList=="0"'>
              <div @click.stop="toProductDetail(item)"
                   class='fds'>
                <div>
                  <van-button size="mini">查看详情</van-button>
                </div>
              </div>
            </div>
            <!-- <div slot="footer"
                 v-else-if='item.whichList=="1"'>
              <div @click="toProductDetail(item)"
                   class='fds'>
                <div>
                  <van-button size="mini"
                              @click='delOrder(item.kid)'>取消订单</van-button>
                  <van-button size="mini">立即付款</van-button>
                </div>
              </div>
            </div>
            <div slot="footer"
                 v-else-if='item.whichList=="2"'>
              <div @click="toProductDetail(item)"
                   class='fds'>
                <div>
                  <van-button size="mini"
                              @click="toTipSend">提醒发货</van-button>
                </div>
              </div>
            </div>
            <div slot="footer"
                 v-else-if='item.whichList=="3"'>
              <div @click="toProductDetail(item)"
                   class='fds'>
                <div>
                  <van-button size="mini"
                              @click="makeGood(item)">确定收货</van-button>
                </div>
              </div>
            </div> -->
          </van-card>
        </div>
        <div class='order-empty'
             v-else>
          <div class='order-empty-bg'>
            <i></i>
          </div>
          <p class="empty-warm">一个订单都没有哦~</p>
          <p class='pick-some'>给自己定一个小目标，先下一单</p>
          <router-link to="/home">
            <van-button size="small">随便逛逛</van-button>
          </router-link>
        </div>
      </van-tab>

      <van-tab title="待付款">
        <div class='order-section'
             v-if='this.goods!=0'>
          <van-card v-for="item in nopaygoods"
                    :title="item.name"
                    :desc="item.color +'-'+ item.size"
                    :num="item.count"
                    :price="item.price"
                    :thumb="item.goodsDetail.src"
                    :key="item.id">
            <div slot="footer">
              <div @click.stop="toProductDetail(item)"
                   class='fds'>
                <div>
                  <van-button size="mini"
                              @click.stop="cancelOrder(item)">取消订单</van-button>
                  <van-button size="mini"
                              @click.stop='toPayMoney(item.id)'>立即付款</van-button>
                </div>
              </div>
            </div>
          </van-card>
        </div>
        <div class='order-empty'
             v-else>
          <div class='order-empty-bg'>
            <i></i>
          </div>
          <p class="empty-warm">一个订单都没有哦~</p>
          <p class='pick-some'>给自己定一个小目标，先下一单</p>
          <router-link to="/home">
            <van-button size="small">随便逛逛</van-button>
          </router-link>
        </div>
      </van-tab>

      <van-tab title="待发货">
        <div class='order-section'
             v-if='this.goods!=0'>
          <van-card v-for="item in waitgoods"
                    :title="item.name"
                    :desc="item.color +'-'+ item.size"
                    :num="item.count"
                    :price="item.price"
                    :thumb="item.goodsDetail.src"
                    :key="item.id">
            <div slot="footer">
              <div @click.stop="toProductDetail(item)"
                   class='fds'>
                <div>
                  <van-button size="mini"
                              @click.stop="toTipSend">提醒发货</van-button>
                </div>
              </div>
            </div>
          </van-card>
        </div>
        <div class='order-empty'
             v-else>
          <div class='order-empty-bg'>
            <i></i>
          </div>
          <p class="empty-warm">一个订单都没有哦~</p>
          <p class='pick-some'>给自己定一个小目标，先下一单</p>
          <router-link to="/home">
            <van-button size="small">随便逛逛</van-button>
          </router-link>
        </div>
      </van-tab>

      <van-tab title="待收货">
        <div class='order-section'
             v-if='this.goods!=0'>
          <router-link to="">
            <van-card v-for="item in sendgoods"
                      :title="item.name"
                      :desc="item.color +'-'+ item.size"
                      :num="item.count"
                      :price="item.price"
                      :thumb="item.goodsDetail.src"
                      :key="item.id">
              <div slot="footer">
                <div class='fds'
                     @click.stop="toProductDetail(item)">
                  <div>
                    <van-button size="mini"
                                @click.stop="makeGood(item)">确定收货</van-button>
                  </div>
                </div>
              </div>
            </van-card>
          </router-link>
        </div>
        <div class='order-empty'
             v-else>
          <div class='order-empty-bg'>
            <i></i>
          </div>
          <p class="empty-warm">一个订单都没有哦~</p>
          <p class='pick-some'>给自己定一个小目标，先下一单</p>
          <router-link to="/home">
            <van-button size="small">随便逛逛</van-button>
          </router-link>
        </div>
      </van-tab>
      <van-tab title="待评价">
        <div class='order-section'
             v-if='this.goods!=0'>
          <router-link to="">
            <van-card v-for="item in assess"
                      :title="item.name"
                      :desc="item.color +'-'+ item.size"
                      :num="item.count"
                      :price="item.price"
                      :thumb="item.goodsDetail.src"
                      :key="item.id">
              <div slot="footer">
                <div class='fds'>
                  <div>
                    <van-button size="mini">去评价</van-button>
                  </div>
                </div>
              </div>
            </van-card>
          </router-link>
        </div>
        <div class='order-empty'
             v-else>
          <div class='order-empty-bg'>
            <i></i>
          </div>
          <p class="empty-warm">一个订单都没有哦~</p>
          <p class='pick-some'>给自己定一个小目标，先下一单</p>
          <router-link to="/home">
            <van-button size="small">随便逛逛</van-button>
          </router-link>
        </div>
      </van-tab>
    </van-tabs>

  </div>
</template>

<script>
import store from '@/vuex/store'
import { mapState } from 'vuex'
import { constants } from 'fs';
import { debug, debuglog } from 'util';
import { Toast, Dialog } from 'vant';
export default {
  store,
  data () {
    return {
      active: 0,
      title: ['全部', '待支付', '待收货', '待评价'],
      goods: [],//全部订单（已支付、待支付）,
      nopaygoods: [],//待支付
      sendgoods: [],//待收货
      assess: [], //待评价
      waitgoods: [] //待发货，就是已支付的订单数组 
    };
  },
  computed: {
    ...mapState({
      selectGoods: state => state.selectGoods,//绑定store.selectGoods到组件，之后可用this.selectGoods获取
      toBuy: state => state.toBuy,//直接购买
      isRightToBuy: state => state.isRightToBuy,
      allGood: state => state.allGood,
      toBepay: state => state.toBepay,
      tosendgood: state => state.tosendgood,
      toAssess: state => state.toAssess
    }),
  },
  created () {
    // //debugger
    //this.allGood.length = 0;
    // this.allGood.push(this.toAssess);
    // this.toBepay.forEach(item => {
    //   this.allGood.push(item);
    // });
    // this.tosendgood.forEach(item => {
    //   this.allGood.push(item);
    // });
    // this.toAssess.forEach(item => {
    //   this.allGood.push(item);
    // })




    this.goods = this.allGood;
    // this.goods.forEach(item => {
    //   this.waitgoods.push(item);
    // })
    this.waitgoods = this.goods;

    this.waitgoods.forEach(item => {
      item.isWaitGoods = 1;
    })

    this.nopaygoods = this.toBepay;
    this.sendgoods = this.tosendgood;
    this.assess = this.toAssess;
    this.active = this.$route.params.active
    console.log('this.allGood');
    console.log(this.allGood);
    console.log('this.tobepay');
    console.log(this.toBepay);
    console.log('this.sendgoods');
    console.log(this.sendgoods);
  },
  methods: {
    //立即付款
    toPayMoney (itemId) {
      alert('付款成功');
    },
    //查看订单详情
    toProductDetail (item) {
      //debugger
      //   alert('sfdsf');

      var isWaitGoods = item.isWaitGoods;
      if (isWaitGoods != undefined) {

      }
      this.$router.push({ name: 'listDetail', params: { kid: item.kid, whichList: item.whichList, isWaitGoods: isWaitGoods } })
    },
    //取消订单
    cancelOrder (thisItem) {
      //debugger;
      Dialog.alert({
        message: '确定取消订单吗？'
      }).then(() => {
        Toast('取消订单成功');
        this.nopaygoods = this.nopaygoods.filter(item => {
          return item.id != thisItem.id;
        });
        this.$store.state.toBepay = this.$store.state.toBepay.filter(item => {
          return item.id != thisItem.id;
        });
      });
    },
    //确定收货
    makeGood (thisitem) {
      //debugger
      console.log(thisitem);
      Toast('收货成功');

      this.sendgoods = this.sendgoods.filter(item => {
        return item.id != thisitem.id
      });
      this.$store.state.tosendgood = this.$store.state.tosendgood.filter(item => {
        return item.id != item.id;
      });
      //this.$store.state.toAssess.push(thisitem);
      this.toAssess.push(thisitem);
    },
    //提醒发货
    toTipSend () {
      //debugger;
      Toast('提醒发货成功');
    },
    onClickLeft () {
      this.$router.push('/my');
    },
    linkToDetail (kid) {
      //详情页跳转，暂时
      // //debugger;
      console.log(kid);
      this.$router.push({ path: `/ listDetail / ${kid}` });
    },
    delOrder (kid) {
      //取消订单
      //从待支付数组中删除改选中的对象,只要点击删除订单，该订单会从全部和待支付中取消
      //删除后，页面从新渲染
      //    //debugger
      this.allGood = this.allGood.filter(item => {
        return item.kid != kid;
      });
      this.toBepay = this.toBepay.filter(item => {
        return item.kid != kid;
      })
      console.log('hhhhnim');
      console.dir(this.allGood);
      console.dir(this.toBepay);

      this.$set(this.allGood);
    }
  },
  //修改
  updated () {
    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been re-rendered

    })
  }
}
</script>

<style lang="less">
.orderList {
  .no-data-text {
    font-size: 0.32rem;
    color: #aaa;
    padding: 10% 0;
    text-align: center;
  }
  .van-tabs--scrollable .van-tab {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 22%;
    flex: 0 0 20%;
  }
  .van-card {
    padding: 0.2rem 0.24rem;
    border-bottom: 1px solid #e5e5e5;

    .van-card__footer {
      width: 100%;
      height: 100%;
      z-index: 9999;
      & > div {
        height: 100%;
        width: 100%;
        & > div {
          height: 100%;
          width: 100%;
          & > div {
            position: absolute;
            right: 5px;
            bottom: 15px;
            z-index: 999999;
          }
        }
      }
    }
  }
}

.order-empty {
  text-align: center;

  .order-empty-bg {
    padding: 0.8rem 2.62rem 0.74rem;

    i {
      display: block;
      width: 2.28rem;
      height: 2.02rem;
      background: url("../../../static/image/myOrder/ios/order.png") no-repeat
        center center;
    }
  }
  .cart-tip {
    padding: 0 0.3rem;
    height: 0.8rem;
    line-height: 0.8rem;
    background: rgb(253, 251, 238);

    span {
      display: block;
      float: left;

      &:nth-child(1) {
        width: 0.3rem;
        height: 0.8rem;
        margin-right: 0.1rem;
        background: url("../../../static/image/goods/splitPic/addCart/ios/notice.png")
          no-repeat center center;
      }
      &:nth-child(2) {
        color: rgb(255, 144, 0);
        font-size: 0.22rem;
      }
      &:nth-child(3) {
        float: right;
        width: 0.3rem;
        height: 0.8rem;
        background: url("../../../static/image/goods/splitPic/addCart/ios/back.png")
          no-repeat center center;
      }
    }
  }

  .cart-ico {
    padding: 0.42rem 2.62rem 0.6rem;
    .cart-icon-p {
      display: block;
      width: 2.28rem;
      height: 2.28rem;
      background: url("../../../static/image/goods/splitPic/addCart/ios/cart.png")
        no-repeat center center;
    }
  }
  .empty-warm {
    font-size: 0.3rem;
    margin-bottom: 0.02rem;
    color: rgb(51, 51, 51);
  }
  .pick-some {
    font-size: 0.24rem;
    color: rgb(123, 123, 123);
    margin-bottom: 0.74rem;
  }
  .van-button--small {
    font-size: 0.34rem;
    color: #fff;
    background-color: rgb(255, 144, 0);
    width: 4.56rem;
    height: 0.8rem;
    line-height: 0.8rem;
    border-radius: 0.2rem;
  }
}
.van-tab--active {
  color: rgb(255, 144, 0);
}
.van-tabs__nav-bar {
  background-color: rgb(255, 144, 0);
}
</style>


// WEBPACK FOOTER //
// src/pages/my/orderList.vue